import { render, staticRenderFns } from "./buyChannelNameSelect.vue?vue&type=template&id=0d0e9a7e&scoped=true"
import script from "./buyChannelNameSelect.vue?vue&type=script&lang=js"
export * from "./buyChannelNameSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e9a7e",
  null
  
)

export default component.exports